module.exports = __webpack_public_path__ + "img/linkedin_icon.54a08088.svg";